import { gaPush } from '@/configuration/setup/googleAnalytics';
import { TyreReading } from '@/generated/GeneratedApiTypes';

const AnalyticsEvents = {
    viewTyresBlock: () => {
        gaPush({
            event: 'view_tyres_block',
            parameters: {
                element_name: 'TyresGrid',
                trigger: 'visibility',
                flow_name: 'vehicle_diagnostic',
            },
            userProps: {},
        });
    },
    hoverTooltipTyresDesktopVehicleDiagnostic: (tyre?: TyreReading) => {
        gaPush({
            event: 'hover_tooltip_tyres',
            parameters: {
                element_name: 'pressure_status, temperature_status',
                trigger: 'visibility',
                flow_name: 'vehicle_diagnostic',
                component_name: 'Popover',
                element_state: `pressure:${tyre?.pressure_status}|temperature:${tyre?.temperature_status}`,
            },
            userProps: {},
        });
    },
    hoverTooltipTyresDesktopWearTear: (tyre?: TyreReading) => {
        gaPush({
            event: 'hover_tooltip_tyres',
            parameters: {
                element_name: 'pressure_status, temperature_status',
                trigger: 'visibility',
                flow_name: 'wear_tear_component_view',
                component_name: 'Popover',
                element_state: `pressure:${tyre?.pressure_status}|temperature:${tyre?.temperature_status}`,
            },
            userProps: {},
        });
    },
    hoverTooltipTyresMobileVehicleDiagnostic: (tyre?: TyreReading) => {
        gaPush({
            event: 'hover_tooltip_tyres',
            parameters: {
                element_name: 'pressure_status, temperature_status',
                trigger: 'click',
                flow_name: 'vehicle_diagnostic',
                component_name: 'BottomSheet',
                element_state: `pressure:${tyre?.pressure_status}|temperature:${tyre?.temperature_status}`,
            },
            userProps: {},
        });
    },
    hoverTooltipTyresMobileWearTear: (tyre?: TyreReading) => {
        gaPush({
            event: 'hover_tooltip_tyres',
            parameters: {
                element_name: 'pressure_status, temperature_status',
                trigger: 'click',
                flow_name: 'wear_tear_component_view',
                component_name: 'BottomSheet',
                element_state: `pressure:${tyre?.pressure_status}|temperature:${tyre?.temperature_status}`,
            },
            userProps: {},
        });
    },
};

export default AnalyticsEvents;
